import { auth } from "../firebaseConfig";
import { LEARNING_CONTENT_API_BASE_URL } from "./learningContentApi";

export class QuizDeletionApiError extends Error {
  constructor(message, status = 0) {
    super(message);
    this.name = "QuizDeletionApiError";
    this.status = status;
  }
}

export const deleteQuizApi = async (quizId) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new QuizDeletionApiError("Please sign in again before deleting this test.", 401);
  }

  const token = await currentUser.getIdToken();
  const response = await fetch(`${LEARNING_CONTENT_API_BASE_URL}/api/quizzes/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ quizId }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok !== true || data.deleted !== true) {
    throw new QuizDeletionApiError(
      data.error || "The test could not be deleted. Please try again.",
      response.status
    );
  }
  return data;
};
